import SetPassword from './SetPassword.vue'

export default {
    path:'set-password',
    component:SetPassword
}